import { focusStore } from '../../store/nowFocusStore';
import AudioEvent from '../../event/audio_event';
import EventBus from '../../event_bus';
export default class ReadController {
    /**
     * instance
     * @type {ReadController}
     * @memberof ReadController
     */
    _instance = null;
    /**
     * name list of target sentence groups
     * @type {Array<string>}
     * @memberof ReadController
     */
    sentenceGroups = [];
    /**
     * switch sentence times in second
     * @type {Array<number>}
     * @memberof ReadController
     */
    sentenceTimes = [];
    /**
     *
     * @type {Array<Object>}
     * @memberof ReadController
     */
    sentences = [];
    /**
     *
     * @type {Array<number>}
     * @memberof ReadController
     */
    turnPageTimes = [];
    /**
     * page name of read groups
     * @type {Array<string>}
     * @memberof ReadController
     */
    turnPageNames = [];
    /**
     * current sentence index
     * @type {number}
     * @memberof ReadController
     */
    currentSentenceIndex = 0;
    /**
     * sound player
     * @type {HTMLAudioElement}
     * @memberof ReadController
     */
    soundPlayer = null;

    nextPageName = "";

    currentPageName = "";
    needTurnPage = false;

    constructor() {
        this.soundPlayer = window.soundManager.soundPlayer;
    }

    /**
     * instance
     * @type {ReadController}
     * @readonly
     * @memberof ReadController
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new ReadController();
        }

        return this._instance;
    }

    getSentences() {
        const groups = focusStore.mainBookPageItemControl.itemControl.getItemsByClassName("sentenceGroup", this).slice();
        const sortGroups = [];
        for (let j = 0; j < this.sentenceGroups.length; j++) {
            for (let i = 0; i < groups.length; i++) {
                console.log("group name:", groups[i].target.name);
                if (this.sentenceGroups[j] == groups[i].target.name) {
                    sortGroups.push(groups.splice(i, 1)[0]);
                }
            }
        }
        if(sortGroups.length < this.sentenceGroups.length) {
            this.needTurnPage = true;
        }
        for (let i = 0; i < sortGroups.length; i++) {
            this.sentences = this.sentences.concat(sortGroups[i].sentences);
            
            const prevEndTime = this.sentenceTimes[this.sentenceTimes.length - 1] || 0;
            const times = sortGroups[i].times;
            const fixedTimes = times.map(time => time + prevEndTime);
            
            this.sentenceTimes = this.sentenceTimes.concat(fixedTimes);
            this.turnPageTimes.push(this.sentenceTimes[this.sentenceTimes.length - 1]);
            this.turnPageNames.push(sortGroups[i].target.parent.pageName);
        }
    }

    trigger() {
        this.getSentences();

        this.currentSentenceIndex = -1;
        
        AudioEvent.Instance.addPlayingCallback(this.onUpdateTime.bind(this));
        AudioEvent.Instance.addPlayEndCallback(this.clearData.bind(this));
        window.soundManager.setCallBackFunc(this.onEnd.bind(this));
        this.currentPageName = this.turnPageNames[0];
        this.nextPageName = this.turnPageNames[0];

        EventBus.getInstance()._app.audioConfig.timeSteps = this.sentenceTimes;
        EventBus.getInstance().getAppRefs().soundManager.setDefaultAudioConfig(this.sentenceTimes);
    }

    onUpdateTime() {
        let timeIndex = 0;

        for (let i = 0; i < this.sentenceTimes.length; i += 2) {
            if (this.soundPlayer.currentTime > 0 && this.soundPlayer.currentTime > this.sentenceTimes[i]) {
                if (this.soundPlayer.currentTime < this.sentenceTimes[i + 1]) {
                    timeIndex = i;
                } else {
                    timeIndex = i + 2;
                }
            }
        }

        for(let i = 0; i < this.turnPageTimes.length; i++) {
            if(this.soundPlayer.currentTime > this.turnPageTimes[i]) {
                if(i + 1 == this.turnPageNames.length && i + 1 < this.sentenceGroups.length) {
                    console.log("turn page")
                    window.soundManager.pauseHandler();
                    window.soundManager.clearTimeUpdate();
                    window.pageControl.gotoPage(window.pageControl.nextPage);
                    focusStore.mainBookPageItemControl.itemControl.initCallBack = this.onTurnPage.bind(this);
                    return;
                }
                this.nextPageName = this.turnPageNames[i + 1];
            }
        }
        
        if(this.nextPageName != this.currentPageName) {
            window.pageControl.gotoPageByName(this.nextPageName);
            this.currentPageName = this.nextPageName;
        }


        if (this.currentSentenceIndex == timeIndex && this.soundPlayer.currentTime > 0) {
            return;
        } else {
            this.currentSentenceIndex = timeIndex;
        }

        this.initSentences();

        if (this.soundPlayer.currentTime == 0) {
            this.currentSentenceIndex = -1;
            return;
        }

        if (timeIndex % 2 == 0) {
            if(this.currentSentenceIndex / 2 < this.sentences.length) {
                this.sentences[this.currentSentenceIndex / 2].target.gotoAndStop(0);
                this.sentences[this.currentSentenceIndex / 2].isShow = true;
            }
        }
    }

    onEnd() {
        this.initSentences();
    }

    initSentences() {
        this.sentences.map(sentence => {
            sentence.sentence_gotoAndStop(1)
            sentence.isShow = false;
        })
    }

    onTurnPage() {
        this.getSentences();
        window.soundManager.seekEndHandler();
    }

    clearData() {
        this.sentenceGroups = [];
        this.sentenceTimes = [];
        this.sentences = [];
        this.turnPageTimes = [];
        this.turnPageNames = [];
        this.nextPageName = "";
        this.currentPageName = "";
    }
}

